export enum buttonSize {
	small = 'smallButton',
	medium = 'mediumButton',
	big = 'bigButton'
}